import { createContext } from 'react'
import type { Track } from './Track'

export const AnalyticsRegionCtx = createContext<Track>(null as any)
